<template>
  <div class="stock-management-navbar">
    <div class="left-navbar">
      <div class="logo-badge">
        <WeezieLogo class="back-button" @click="backToHub" />
      </div>

      <div class="page-name">
        {{ pageName }}
      </div>
    </div>

    <div class="right-navbar" v-on-clickaway="closeWindow">
      <v-layout row justify-end align-center id="badge">
        <v-badge
          :content="null"
          :value="messages.length"
          color="red"
          dot
          overlap
          class="notifications-badge"
        >
          <v-btn icon @click="onNotificationButtonClick">
            <v-icon color="#231E46" size="0.65rem"> notifications_none </v-icon>
          </v-btn>
        </v-badge>
      </v-layout>

      <UserButton
        @click.native="onUserButtonClick"
        avatarWidth="1.5rem"
        avatarHeight="1.5rem"
        nameSize="8px"
        class="navbar-user-button"
        id="userButton"
      />
      <transition name="slide-fade">
        <notifications-window
          :right="width"
          top="35px"
          v-show="notificationWindow"
          :notificationOpen="notificationWindow"
          @notifications="setNotificationNumber"
        />
      </transition>

      <UserWindow right="15px" top="40px" v-show="userWindow" />
    </div>

    <ActivateTwoAuthenticationDialog
      :open="opened2FArequired"
      @close="opened2FArequired = false"
      @activateAuthenticate="twoFactorAuthentication = true"
    />
    <div></div>
  </div>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { mixin as clickaway } from "vue-clickaway";
import { twoFactorAuthenticationMixin } from "@/mixins/twoFactorAuthenticationMixin";
import ActivateTwoAuthenticationDialog from "@/components/User/Navbar/UserWindow/ActivateTwoAuthenticationDialog";

import NotificationsSVG from "@/assets/management/notifications.svg";

import UserButton from "@/newComponents/_Molecules/UserButton";
import UserWindow from "@/components/User/Navbar/UserWindow/UserWindow";
import ManagementPage from "./ManagementPage.vue";
import WeezieLogo from "@/assets/logos/WeezieLogo.vue";

export default {
  name: "NavBar",

  components: {
    NotificationsSVG,
    UserButton,
    UserWindow,
    ActivateTwoAuthenticationDialog,
    ManagementPage,
    WeezieLogo,
  },

  mixins: [clickaway, checkPermissionsMixin, twoFactorAuthenticationMixin],

  props: {
    /**
     * Determines if sidebar is open
     */
    sidebarIsOpen: Boolean,

    /**
     * Determines the title of the page
     */
    pageName: String,
  },

  data() {
    return {
      /**
       * Determines if the user window is open
       */
      userWindow: false,
      /**
       * Store notification messages
       */
      messages: [],
      /**
       * Determines if the notification window is open
       */
      notificationWindow: false,

      /**
       * Determines position notification window
       */
      width: "0",
    };
  },

  mounted() {
    setTimeout(() => {
      this.companie2FArequired();
    }, 500);
  },

  methods: {
    /**
     * Close user window
     */
    closeWindow() {
      this.userWindow = false;
    },

    /**
     * Checks if the readAt is null, if so, the notifications get filtered to message data property to use with vuetify badge
     * @param {Array} data - Array of notifications
     */
    setNotificationNumber(data) {
      this.messages = data.filter((item) => !item.readAt);
    },

    /**
     * Clicking the user button opens/closes the notification window and closes the user window
     */
    onNotificationButtonClick() {
      this.width =
        document.getElementById("userButton").clientWidth + 90 + "px";
      this.notificationWindow = !this.notificationWindow;
      this.userWindow = false;
    },

    /**
     * Clicking the user button opens/closes the user window and closes the notification window
     */
    onUserButtonClick() {
      this.userWindow = !this.userWindow;
      this.notificationWindow = false;
    },

    /**
     * Sends an event to the parent component to open/close the sidebar
     */
    toggleSidebar() {
      this.$emit("toggle-nav");
    },

    async backToHub() {
      await this.$router.push({ name: "hub" });
    },
  },
};
</script>
<style scoped>
.left-navbar {
  display: flex;
  align-items: center;
  gap: 27.5px;
  padding-left: 20px;
}
.logo-badge {
  width: 2.1rem;
  height: 1.80rem;
}
.back-button {
  cursor: pointer;
}
.page-name {
  color: #767676;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  text-transform: uppercase;
}
.right-navbar {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: 74.5px;
}
.badge {
  border-radius: 5rem;
  background: #fff;
}
.navbar-user-button {
  border-radius: 5rem !important;
  padding: 4px;
  display: flex;
  align-items: center;
}
.notifications-badge {
  background: rgb(255, 255, 255);
  border-radius: 0.15rem;
  height: 0.89rem;
  width: 0.89rem;
  cursor: pointer;
  justify-content: center;
  display: flex;
  align-items: center;
  margin: 0.05rem !important;
  box-shadow: 3.5px 4.5px 7.5px 0px rgba(0, 0, 0, 0.15);
}
.notifications-badge > .v-btn:before,
.notifications-badge > .v-btn--active:not(:hover)::before,
.notifications-badge > .v-btn:focus:before {
  background-color: transparent !important;
  opacity: 0;
}

.notifications-badge > .v-btn >>> .v-ripple__container {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/_Organisms/NavBar.vue